// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2RI7l","file":"styles_file__4ieRk"};